import React, { useState } from 'react';
import { Button, message, Modal } from 'antd';
import http from '@/assets/api/http';

const Index = (props) => {
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line react/prop-types
  const { data: { record }, closeModal } = props;

  const handleOk = () => {
    setLoading(true);
    http('/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.updateReceiveCodeStatus', {
      // eslint-disable-next-line react/prop-types
      userId: record.userId,
      // eslint-disable-next-line react/prop-types
      receiveCodeStatus: record.receiveCodeStatus == '1' ? '0' : '1'
    }, 'POST').then(res => {
      if (res && res.errCode === 0) {
        // eslint-disable-next-line react/prop-types
        message.success(record.receiveCodeStatus == '1' ? '禁用成功' : '启用成功');
        closeModal(true);
      } else {
        message.error('操作失败');
      }
      setLoading(false);
    });
  };
  const handleCancel = () => {
    closeModal(false);
  };
  return (
    <Modal
      width={350}
      centered
      // eslint-disable-next-line react/prop-types
      title={record.receiveCodeStatus == '1' ? '禁用收件码' : '启用收件码'}
      visible={true}
      confirmLoading={loading}
      onOk={handleOk}
      onCancel={handleCancel}
      destroyOnClose={true}
      keyboard={true}
      maskClosable={false}
      cancelText="取消"
      okText="确定"
    //   footer={[
    //     <Button key={1} style={{background:'#188FFF',color:'#ffffff'}} onClick={handleOk}>确定</Button>,
    //     <Button key={2} style={{background:'#AAAAAA',color:'#ffffff'}} onClick={handleCancel}>取消</Button>,
    //   ]}
    >
      <div>{record.receiveCodeStatus == '1' ? '禁用收件码时，骑手送货上门时将不在输入收件码，确定禁用收件码？' : '启用收件码时，骑手送货上门时必须输入收件码，确定启用收件码？'}</div>
    </Modal>
  );
};

export default Index;
